'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var format = require('quick-format-unescaped');
module.exports = pino;
var _console = pfGlobalThisOrFallback().console || {};
var stdSerializers = {
    mapHttpRequest: mock,
    mapHttpResponse: mock,
    wrapRequestSerializer: passthrough,
    wrapResponseSerializer: passthrough,
    wrapErrorSerializer: passthrough,
    req: mock,
    res: mock,
    err: asErrValue,
    errWithCause: asErrValue
};
function levelToValue(level, logger) {
    return level === 'silent' ? Infinity : logger.levels.values[level];
}
var baseLogFunctionSymbol = Symbol('pino.logFuncs');
var hierarchySymbol = Symbol('pino.hierarchy');
var logFallbackMap = {
    error: 'log',
    fatal: 'error',
    warn: 'error',
    info: 'log',
    debug: 'log',
    trace: 'log'
};
function appendChildLogger(parentLogger, childLogger) {
    var newEntry = {
        logger: childLogger,
        parent: parentLogger[hierarchySymbol]
    };
    childLogger[hierarchySymbol] = newEntry;
}
function setupBaseLogFunctions(logger, levels, proto) {
    var logFunctions = {};
    levels.forEach(function(level) {
        logFunctions[level] = proto[level] ? proto[level] : _console[level] || _console[logFallbackMap[level] || 'log'] || noop;
    });
    logger[baseLogFunctionSymbol] = logFunctions;
}
function shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        var hasToFilter = serialize.filter(function(k) {
            return k !== '!stdSerializers.err';
        });
        return hasToFilter;
    } else if (serialize === true) {
        return Object.keys(serializers);
    }
    return false;
}
function pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    var transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== 'function') {
        throw Error('pino: transmit option must have a send function');
    }
    var proto = opts.browser.write || _console;
    if (opts.browser.write) opts.browser.asObject = true;
    var serializers = opts.serializers || {};
    var serialize = shouldSerialize(opts.browser.serialize, serializers);
    var stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf('!stdSerializers.err') > -1) stdErrSerialize = false;
    var customLevels = Object.keys(opts.customLevels || {});
    var levels = [
        'error',
        'fatal',
        'warn',
        'info',
        'debug',
        'trace'
    ].concat(customLevels);
    if (typeof proto === 'function') {
        levels.forEach(function(level) {
            proto[level] = proto;
        });
    }
    if (opts.enabled === false || opts.browser.disabled) opts.level = 'silent';
    var level = opts.level || 'info';
    var logger = Object.create(proto);
    if (!logger.log) logger.log = noop;
    setupBaseLogFunctions(logger, levels, proto);
    // setup root hierarchy entry
    appendChildLogger({}, logger);
    Object.defineProperty(logger, 'levelVal', {
        get: getLevelVal
    });
    Object.defineProperty(logger, 'level', {
        get: getLevel,
        set: setLevel
    });
    var setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        formatters: opts.browser.formatters,
        levels: levels,
        timestamp: getTimeFunction(opts),
        messageKey: opts.messageKey || 'msg',
        onChild: opts.onChild || noop
    };
    logger.levels = getLevels(opts);
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _child;
        return (_child = child).call.apply(_child, [
            this,
            setOpts
        ].concat(_to_consumable_array(args)));
    };
    if (transmit) logger._logEvent = createLogEventShape();
    function getLevelVal() {
        return levelToValue(this.level, this);
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        var _this = this;
        if (level !== 'silent' && !this.levels.values[level]) {
            throw Error('unknown level ' + level);
        }
        this._level = level;
        set(this, setOpts, logger, 'error') // <-- must stay first
        ;
        set(this, setOpts, logger, 'fatal');
        set(this, setOpts, logger, 'warn');
        set(this, setOpts, logger, 'info');
        set(this, setOpts, logger, 'debug');
        set(this, setOpts, logger, 'trace');
        customLevels.forEach(function(level) {
            set(_this, setOpts, logger, level);
        });
    }
    function child(setOpts, bindings, childOptions) {
        if (!bindings) {
            throw new Error('missing bindings for child Pino');
        }
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) {
            childOptions.serializers = bindings.serializers;
        }
        var childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            // make sure bindings are available in the `set` function
            this.bindings = bindings;
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) {
                this._logEvent = createLogEventShape([].concat(parent._logEvent.bindings, bindings));
            }
        }
        Child.prototype = this;
        var newLogger = new Child(this);
        // must happen before the level is assigned
        appendChildLogger(this, newLogger);
        newLogger.child = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _child;
            return (_child = child).call.apply(_child, [
                this,
                setOpts
            ].concat(_to_consumable_array(args)));
        };
        // required to actually initialize the logger functions for any given child
        newLogger.level = childOptions.level || this.level // allow level to be set by childOptions
        ;
        setOpts.onChild(newLogger);
        return newLogger;
    }
    return logger;
}
function getLevels(opts) {
    var customLevels = opts.customLevels || {};
    var values = Object.assign({}, pino.levels.values, customLevels);
    var labels = Object.assign({}, pino.levels.labels, invertObject(customLevels));
    return {
        values: values,
        labels: labels
    };
}
function invertObject(obj) {
    var inverted = {};
    Object.keys(obj).forEach(function(key) {
        inverted[obj[key]] = key;
    });
    return inverted;
}
pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: 'trace',
        20: 'debug',
        30: 'info',
        40: 'warn',
        50: 'error',
        60: 'fatal'
    }
};
pino.stdSerializers = stdSerializers;
pino.stdTimeFunctions = Object.assign({}, {
    nullTime: nullTime,
    epochTime: epochTime,
    unixTime: unixTime,
    isoTime: isoTime
});
function getBindingChain(logger) {
    var bindings = [];
    if (logger.bindings) {
        bindings.push(logger.bindings);
    }
    // traverse up the tree to get all bindings
    var hierarchy = logger[hierarchySymbol];
    while(hierarchy.parent){
        hierarchy = hierarchy.parent;
        if (hierarchy.logger.bindings) {
            bindings.push(hierarchy.logger.bindings);
        }
    }
    return bindings.reverse();
}
function set(self1, opts, rootLogger, level) {
    // override the current log functions with either `noop` or the base log function
    Object.defineProperty(self1, level, {
        value: levelToValue(self1.level, rootLogger) > levelToValue(level, rootLogger) ? noop : rootLogger[baseLogFunctionSymbol][level],
        writable: true,
        enumerable: true,
        configurable: true
    });
    if (self1[level] === noop) {
        if (!opts.transmit) return;
        var transmitLevel = opts.transmit.level || self1.level;
        var transmitValue = rootLogger.levels.values[transmitLevel];
        var methodValue = rootLogger.levels.values[level];
        if (methodValue < transmitValue) return;
    }
    // make sure the log format is correct
    self1[level] = createWrap(self1, opts, rootLogger, level);
    // prepend bindings if it is not the root logger
    var bindings = getBindingChain(self1);
    if (bindings.length === 0) {
        // early exit in case for rootLogger
        return;
    }
    self1[level] = prependBindingsInArguments(bindings, self1[level]);
}
function prependBindingsInArguments(bindings, logFunc) {
    return function() {
        return logFunc.apply(this, _to_consumable_array(bindings).concat(Array.prototype.slice.call(arguments)));
    };
}
function createWrap(self1, opts, rootLogger, level) {
    return function(write) {
        return function LOG() {
            var ts = opts.timestamp();
            var args = new Array(arguments.length);
            var proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === _console ? _console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            var argsIsSerialized = false;
            if (opts.serialize) {
                applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
                argsIsSerialized = true;
            }
            if (opts.asObject || opts.formatters) {
                write.call(proto, asObject(this, level, args, ts, opts));
            } else write.apply(proto, args);
            if (opts.transmit) {
                var transmitLevel = opts.transmit.level || self1._level;
                var transmitValue = rootLogger.levels.values[transmitLevel];
                var methodValue = rootLogger.levels.values[level];
                if (methodValue < transmitValue) return;
                transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: rootLogger.levels.values[opts.transmit.level || self1._level],
                    send: opts.transmit.send,
                    val: levelToValue(self1._level, rootLogger)
                }, args, argsIsSerialized);
            }
        };
    }(self1[baseLogFunctionSymbol][level]);
}
function asObject(logger, level, args, ts, opts) {
    var _ref = opts.formatters || {}, levelFormatter = _ref.level, tmp = _ref.log, logObjectFormatter = tmp === void 0 ? function(obj) {
        return obj;
    } : tmp;
    var argsCloned = args.slice();
    var msg = argsCloned[0];
    var logObject = {};
    if (ts) {
        logObject.time = ts;
    }
    if (levelFormatter) {
        var formattedLevel = levelFormatter(level, logger.levels.values[level]);
        Object.assign(logObject, formattedLevel);
    } else {
        logObject.level = logger.levels.values[level];
    }
    var lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && (typeof msg === "undefined" ? "undefined" : _type_of(msg)) === 'object') {
        while(lvl-- && _type_of(argsCloned[0]) === 'object'){
            Object.assign(logObject, argsCloned.shift());
        }
        msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === 'string') msg = format(argsCloned.shift(), argsCloned);
    if (msg !== undefined) logObject[opts.messageKey] = msg;
    var formattedLogObject = logObjectFormatter(logObject);
    return formattedLogObject;
}
function applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(var i in args){
        if (stdErrSerialize && args[i] instanceof Error) {
            args[i] = pino.stdSerializers.err(args[i]);
        } else if (_type_of(args[i]) === 'object' && !Array.isArray(args[i]) && serialize) {
            for(var k in args[i]){
                if (serialize.indexOf(k) > -1 && k in serializers) {
                    args[i][k] = serializers[k](args[i][k]);
                }
            }
        }
    }
}
function transmit(logger, opts, args) {
    var argsIsSerialized = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var send = opts.send;
    var ts = opts.ts;
    var methodLevel = opts.methodLevel;
    var methodValue = opts.methodValue;
    var val = opts.val;
    var bindings = logger._logEvent.bindings;
    if (!argsIsSerialized) {
        applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    }
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = createLogEventShape(bindings);
}
function createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: '',
            value: 0
        }
    };
}
function asErrValue(err) {
    var obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(var key in err){
        if (obj[key] === undefined) {
            obj[key] = err[key];
        }
    }
    return obj;
}
function getTimeFunction(opts) {
    if (typeof opts.timestamp === 'function') {
        return opts.timestamp;
    }
    if (opts.timestamp === false) {
        return nullTime;
    }
    return epochTime;
}
function mock() {
    return {};
}
function passthrough(a) {
    return a;
}
function noop() {}
function nullTime() {
    return false;
}
function epochTime() {
    return Date.now();
}
function unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== 'undefined' && o;
    }
    try {
        if (typeof globalThis !== 'undefined') return globalThis;
        Object.defineProperty(Object.prototype, 'globalThis', {
            get: function get() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
}
/* eslint-enable */ module.exports.default = pino;
module.exports.pino = pino;
